/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PointType
 */
export interface PointType {
    /**
     * 포인트 유형 id
     * @type {number}
     * @memberof PointType
     */
    'pointTypeId': number;
    /**
     * 유형
     * @type {string}
     * @memberof PointType
     */
    'type': PointTypeTypeEnum;
}

export const PointTypeTypeEnum = {
    Like: 'like',
    Follow: 'follow',
    Comment: 'comment',
    Pagelike: 'pagelike',
    Subscribe: 'subscribe',
    Post: 'post',
    Install: 'install',
    Rating: 'rating',
    Join: 'join',
    Friend: 'friend',
    Event: 'event',
    Blog: 'blog',
    Scrap: 'scrap',
    Bookmark: 'bookmark',
    Notification: 'notification',
    CampaignReport: 'campaign_report',
    UserReport: 'user_report',
    Admin: 'admin',
    Badge: 'badge',
    SnsAccountDelete: 'sns_account_delete',
    Exchange: 'exchange'
} as const;

export type PointTypeTypeEnum = typeof PointTypeTypeEnum[keyof typeof PointTypeTypeEnum];


